import type { ConversationType } from 'owa-graph-schema';
import { ITEM_CLASS_SMIME } from 'owa-smime-adapter/lib/utils/bootConstants';

/**
 * Returns true if the conversation contains S/MIME item
 */
export default function doesConversationContainSmimeItem(
    conversation: Partial<ConversationType>
): boolean {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (13,5): Type 'boolean | null | undefined' is not assignable to type 'boolean'.
    // @ts-expect-error
    return (
        conversation?.ItemClasses &&
        conversation.ItemClasses.length > 0 &&
        conversation.ItemClasses.some(itemClass => itemClass.indexOf(ITEM_CLASS_SMIME) === 0)
    );
}
